
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import { STATUS_SELECT_ARRAY } from "@/model/event";
import { Component } from "vue-property-decorator";

@Component({
  name: "qReleaseSettingLive",
})
export default class QReleaseSettingEvent extends QReleaseSetting {
  public statusList = STATUS_SELECT_ARRAY;
}
